export function initBackgrounds() {
    const main = document.querySelector('main.content-wrapper.main');
    if (!main) return;

    const body = document.body;

    const pageColours = {
        strategie: "#C7F7E1",
        design: "#D3F5FE",
        development: "#FFECB4",
        barrierefreiheit: "#DDD6F1",
        ki: "#FFFFFF",
        "ueber-uns": "#DDD6F1",
        briefing: "#D3F5FE",
        home: "#FAFBEF"
    };

    const pageClass = Object.keys(pageColours).find(cls => body.classList.contains(cls));
    const defaultColor = pageClass ? pageColours[pageClass] : "#FAFBEF";

    main.style.backgroundColor = defaultColor;
    main.style.transition = "background-color 0.5s ease";

    let colorStops = [];

    // Detect device type
    const width = window.innerWidth;
    const isMobile = width <= 768;
    const isTablet = width > 768 && width <= 1024; // define tablet breakpoint

    // Helper function to pick stops based on device
    const pickStops = (desktopStops, tabletStops, mobileStops) => {
        if (isMobile && mobileStops) return mobileStops;
        if (isTablet && tabletStops) return tabletStops;
        return desktopStops;
    };

    if (body.classList.contains('home')) {
        colorStops = pickStops(
            [ // desktop
                {percent: 0, color: defaultColor},
                {percent: 0.03, color: "#6FE79F"},
                {percent: 0.37, color: "#FAFBEF"},
                {percent: 0.75, color: "#FFECB4"}
            ],
            [ // tablet
                {percent: 0, color: defaultColor},
                {percent: 0.05, color: "#6FE79F"},
                {percent: 0.30, color: "#FAFBEF"},
                {percent: 0.67, color: "#FFECB4"}
            ],
            [ // mobile
                {percent: 0, color: defaultColor},
                {percent: 0.02, color: "#6FE79F"},
                {percent: 0.25, color: "#FAFBEF"},
                {percent: 0.78, color: "#FFECB4"}
            ]
        );
    } else if (body.classList.contains('ki')) {
        colorStops = pickStops(
            [
                {percent: 0, color: "#FFFFFF"},
                {percent: 0.65, color: "#F9F9F9"}],
            [
                {percent: 0, color: "#FFFFFF"},
                {percent: 0.65, color: "#F9F9F9"}],
            [
                {percent: 0, color: "#FFFFFF"},
                {percent: 0.6, color: "#F9F9F9"}]
        );
    } else if (body.classList.contains('ueber-uns')) {
        colorStops = pickStops(
            [
                {percent: 0, color: defaultColor},
                {percent: 0.5, color: "#C7F7E1"},
                {percent: 0.6, color: "#D3F5FE"}
            ],
            [
                {percent: 0, color: defaultColor},
                {percent: 0.50, color: "#C7F7E1"},
                {percent: 0.62, color: "#D3F5FE"}],
            [
                {percent: 0, color: defaultColor},
                {percent: 0.40, color: "#C7F7E1"},
                {percent: 0.55, color: "#D3F5FE"}
            ]
        );
    } else if (["strategie", "development", "barrierefreiheit", "design"].includes(pageClass)) {
        colorStops = pickStops(
            [
                {percent: 0, color: defaultColor}, 
                {percent: 0.31, color: "#FAFBEF"}],
            [
                {percent: 0, color: defaultColor}, 
                {percent: 0.30, color: "#FAFBEF"}],
            [
                {percent: 0, color: defaultColor}, 
                {percent: 0.26, color: "#FAFBEF"}]
        );
    } else {
        colorStops = [{percent: 0, color: defaultColor}];
    }

    window.addEventListener("scroll", () => {
        const scrollTop = window.scrollY;
        const docHeight = document.body.scrollHeight - window.innerHeight;
        const scrollPercent = scrollTop / docHeight;

        let currentColor = defaultColor;
        for (let i = 0; i < colorStops.length; i++) {
            if (scrollPercent >= colorStops[i].percent) {
                currentColor = colorStops[i].color;
            }
        }

        main.style.backgroundColor = currentColor;
    });
}
